import { createSelector } from 'reselect';
import { RootState } from '../reducers';

const stateSelector = (state: RootState) => state.checkpoint;

export const checkpointSelector = createSelector(stateSelector, (value) => value);
